// lib-jitsi-meet (meet.jit.si CDN) bundles an old webrtc-adapter whose Firefox addTransceiver shim
// does `init.sendEncodings.forEach` whenever the key exists, even if its value is undefined.
// Webex's media engine calls addTransceiver({ direction, sendEncodings: undefined }) for audio,
// so joining a Webex meeting throws in Firefox. Drop the undefined key before it reaches the shim.
export function patchAddTransceiverUndefinedEncodings(): void {
  const proto = window.RTCPeerConnection?.prototype;
  if (!proto?.addTransceiver || (proto as any).__undefinedEncodingsPatched) return;

  const original = proto.addTransceiver;
  proto.addTransceiver = function (
    this: RTCPeerConnection,
    trackOrKind: MediaStreamTrack | string,
    init?: RTCRtpTransceiverInit
  ) {
    if (init && 'sendEncodings' in init && init.sendEncodings === undefined) {
      init = { ...init };
      delete init.sendEncodings;
    }
    return original.call(this, trackOrKind, init);
  } as typeof proto.addTransceiver;
  (proto as any).__undefinedEncodingsPatched = true;
}
